import { render, staticRenderFns } from "./zhipaiyouhuoCYS.vue?vue&type=template&id=e38f2cd8&scoped=true&"
import script from "./zhipaiyouhuoCYS.vue?vue&type=script&lang=js&"
export * from "./zhipaiyouhuoCYS.vue?vue&type=script&lang=js&"
import style0 from "./zhipaiyouhuoCYS.vue?vue&type=style&index=0&id=e38f2cd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38f2cd8",
  null
  
)

export default component.exports